import React from 'react'
import { Platform, View } from 'react-native'
import Button from '@ui/buttons/Button'
import { ButtonProps } from '@ui/buttons/Button/types'
import Typography from '@ui/typography'
import FormattedText from '@ui/typography/FormattedText'
import { header } from '@ui/theme/values'
import SpaceTop from '@ui/elements/Space'

interface Props {
  title?: string
  desc?: string
  body?: React.ReactNode
  button?: ButtonProps
  list?: boolean
}

export default function Header({ title, desc, body, button, list }: Props) {
  return (
    <>
      {list && <SpaceTop />}
      <View
        className="items-center justify-between gap-8"
        style={{
          paddingHorizontal: 64,
          paddingTop: Platform.select({ default: 24, web: 32 }),
          height: header.height,
        }}
      >
        <View className="w-full items-center gap-4">
          {title && (
            <Typography variant="H4" className="text-center leading-none">
              {title}
            </Typography>
          )}
          {desc && (
            <FormattedText
              variant="MD"
              className="color-desc w-full text-center"
              classNameBold="color-text"
              text={desc}
              style={[{ maxWidth: header.description.maxWidth }]}
            />
          )}
          {body}
        </View>
        {button && <Button size="md" variant="outlined" {...button} />}
      </View>
    </>
  )
}
